export default __webpack_public_path__ + "static/6-d9e8df694b9a8afdbc61b4f4fb37eff0.png";